<section class="pt-2">
  <div class="container-style">
    <div class="row align-items-center mx-0 p-1">
      <div class="col-lg-6 col-md-12 col-sm-12 col-12">
        <span id="span-title" class="fw-bold">{{ isFormView ? 'Registrar detalle del formato' : '' }} </span>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end" *ngIf="showNewDetail">
        <div class="d-flex gap-2">
          <app-custom-button [label]="'Nuevo Detalle'" [severity]="'success'" [disabled]="disabledDetail"
            [width]="'6.5rem'" (onClick)="createNewDetail()"></app-custom-button>
        </div>
      </div>
    </div>
    <div [hidden]="!isFormView" class="row mx-0">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12">
        <app-register-format-detail [formatModel]="formatModel" [formatDetailContract]="formatDetailModel"
          (updateListDetail)="getFormatDetailsByFormat()" (isFormView)="getFormView($event)">
        </app-register-format-detail>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions" [showRecover]="true"
        [showCheckbox]="showCheckbox" [checkBoxAction]="checkboxActions" [clearSelectionTrigger]="clearSelectionTrigger"
        [previousFilters]="filters" (onRecoverData)="getFormatDetailsByFormat()" (onPageChange)="onPageChange($event)"
        (onFilterChange)="onFilterChange($event)" (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>